import React, { useContext } from 'react';

import { ACTIONS, BOOKINGS_TABS } from '../../../Bookings';
import ActionButtonGroup from "../../../../../Components/Buttons/ActionButtonGroup";
import CancelBookingButton from "../../ActionButtons/CancelBookingButton";
import DeleteBookingButton from "../../ActionButtons/DeleteBookingButton";
import EditBookingButton from "../../ActionButtons/EditBookingButton";
import ViewBookingButton from "../../ActionButtons/ViewBookingButton";
import { TabContext } from "../../../Pages/BookingsLog";

const BookingActionsCell = (props) => {
    const tabState = useContext(TabContext);

    const actions = (tabState.scope === BOOKINGS_TABS.UPCOMING)
        ? [ ACTIONS.VIEW, ACTIONS.EDIT, ACTIONS.REMOVE, ACTIONS.DELETE ]
        : [ ACTIONS.VIEW, ACTIONS.DELETE ];

    /**
     * Logic to determine if the delete button should be shown
     *
     * @returns {boolean}
     */
    const showDeleteButton = () => {
        if (!props.row.can_delete || !actions.includes(ACTIONS.DELETE)) {
            return false;
        }

        if (props.row.can_archive && !props.row.archived_at) {
            return false;
        }

        return true
    }

    return (
        <ActionButtonGroup>
            { actions.includes(ACTIONS.VIEW) &&
                <ViewBookingButton
                    booking={props.row}
                    onClick={props.onViewClick}
                />
            }
            { actions.includes(ACTIONS.EDIT) &&
                <EditBookingButton booking={props.row}/>
            }

            { (actions.includes(ACTIONS.REMOVE) && !props.row.archived_at) &&
                <CancelBookingButton booking={props.row}/>
            }

            { (showDeleteButton()) &&
                <DeleteBookingButton booking={props.row}/>
            }
        </ActionButtonGroup>
    )

}

BookingActionsCell.defaultProps = {
    onViewClick: () => null
}

export default BookingActionsCell;
